import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/help')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_dashboard/help"!</div>
}
